import React from "react";
import { ShieldCheck, MessageCircle } from "lucide-react";
import SEO from "@/components/SEO";
import { PageHero, Section } from "@/components/ui-helpers";
import AskAscendiaChat from "@/components/AskAscendiaChat";

const HELP = ["Choosing the right service", "Surface-care & stain guidance", "Post-construction dust", "Move-in preparation", "Package differences", "Preparing for your appointment"];

export default function AskAscendia() {
  return (
    <>
      <SEO title="Ask Ascendia — AI Cleaning Assistant" description="Get safe, honest cleaning and detailing guidance from Ascendia's AI assistant. Upload a photo for tailored advice." />
      <PageHero kicker="Ask Ascendia" title="Your cleaning & detailing questions, answered" subtitle="General guidance on cleaning, stains, surfaces and property prep. Upload a photo and we'll take a look — safely and honestly." />
      <Section>
        <div className="grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2"><AskAscendiaChat /></div>
          <div className="space-y-5">
            <div className="ascendia-card card-accent-top p-6">
              <h3 className="font-display text-lg font-semibold text-white u-tracking-tight">What we can help with</h3>
              <ul className="mt-4 space-y-2.5">{HELP.map((h) => <li key={h} className="flex items-center gap-2.5 text-sm text-secondary"><ShieldCheck className="h-4 w-4 text-gold-soft" /> {h}</li>)}</ul>
            </div>
            <div className="ascendia-card p-6">
              <h3 className="font-display text-lg font-semibold text-white u-tracking-tight">A note on safety</h3>
              <p className="mt-3 text-sm text-muted-c leading-relaxed">Ask Ascendia provides general guidance only. We never advise mixing chemicals, and for anything delicate, expensive or uncertain we'll always recommend a professional assessment.</p>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
